var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f93838aa-a724-4b2e-b75e-61b6dea67e4c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-c7a16527-6961-49b7-a896-40beccd770c3{fill:#fff;}.uuid-35ecad4c-e47e-4675-a64e-d4016532304a{fill:#1a4687;}.uuid-bfc9436d-b504-4b0f-ae51-8fc0fbce0954{fill:url(#uuid-e6f0d897-704f-4d8a-b952-8e9825d0e19f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e6f0d897-704f-4d8a-b952-8e9825d0e19f",
    x1: 262.86,
    y1: 10699.08,
    x2: 262.86,
    y2: 11025.69,
    gradientTransform: "translate(0 11119.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fffefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fefbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fdf5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fbedd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f9e3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f7d793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f4c86b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f1b73e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#efaf28"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-35ecad4c-e47e-4675-a64e-d4016532304a",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-bfc9436d-b504-4b0f-ae51-8fc0fbce0954",
    d: "m274.29,113.65l9.14.64v155.43c0,35.24,0,59.43-9.14,86.86-6.44,19.31-15.69,29.56-26.6,35.53-9.01,4.94-19.78,4.42-29.79,2.11,26.64-3.28,38.1-14.78,47.24-37.64,9.14-22.86,9.14-45.71,9.14-77.71V113.65l-27.43,14.35h9.14v137.14c0,32.14.25,63.66-5.05,82.29-5.34,16.91-14.21,25.9-22.45,30.9-8.31,5.05-18.6,4.34-27.98,1.83-1.32,0-2.63-.73-3.96-.73,2.65,7.12,7.93,13.51,15.1,14.78,2.08,6.4,8.69,11.51,15.3,12.78,4.72,8.95,13.98,13.51,23.98,13.51,13.22.73,24.56-5.11,35.13-11.5,32.48-22.45,43.06-71.2,43.06-137.86V82.29l-27.43,16.15-27.43,15.21Zm36.39,157.5c0,48.2-2.47,76.28-13.53,99.14-8.38,17.33-20.45,30.56-33.28,37.06-7.76,3.93-16.79,3.17-25.29,1.37l-5.56-1.17c27.95,0,47.15-22.06,54.99-41.83,7.84-19.77,13.71-45.71,13.71-91.43V98.43l9.14,2.14v170.58h-.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c7a16527-6961-49b7-a896-40beccd770c3",
    d: "m242.29,338.29c-10.01,35.24-34.01,41.69-41.94,41.69-13.98,0-26.63-8.95-26.63-67.38v-148.02l73.14-36.57v146.29c0,18.29.15,47.94-4.57,64Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnh);
export default __webpack_public_path__ + "static/media/icon_unh.b60249455dc32b6f82af8ac1ad90fb35.svg";
export { ForwardRef as ReactComponent };